export default __webpack_public_path__ + "static/image12-2be21a065183cae85d2ad3206062f0d7.jpg";